import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('dashboard');
const GET_DASHBOARD = define('GET_DASHBOARD', true);

const initialState = {
  data: {},
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD.PENDING:
      return {
        loading: true,
        data: {},
      };
    case GET_DASHBOARD.RESOLVED:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case GET_DASHBOARD.REJECTED: {
      return {
        ...state,
        loading: false,
      };
    }
    default: return state;
  }
}

export const actions = {
  loadDashboard: (from, to) => ({
    type: GET_DASHBOARD,
    promise: api.get(`/affiliate/report?from=${from}&to=${to}`)
  })
}


// WEBPACK FOOTER //
// ./src/ducks/dashboard.js